import { getStoryBySlug } from "@cinch-nx/data-storyblok";
export const getStaticPropsGenerator = ({ path  })=>{
    return async ({ params , preview =false  })=>{
        try {
            const slug = params === null || params === void 0 ? void 0 : params.slug;
            const story = await getStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                cv: Date.now(),
                resolve_relations: "JargonPage.relatedJargon"
            });
            if (!story) {
                throw new Error("No story within jargon");
            }
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        }
    };
};
